module.exports = "<aside class=\"al-sidebar\" sidebarResize>\n  <div>\n    <!--<div class=\"userImageDiv\">-->\n      <!--<img class=\"userImageSidebar\" src=\"{{userProfileImage}}\">-->\n    <!--</div>-->\n    <div class=\"userProfileName\">\n\n    </div>\n\n  </div>\n  <ba-menu [menuHeight]=\"menuHeight\"\n           [sidebarCollapsed]=\"isMenuCollapsed\"\n           (expandMenu)=\"menuExpand()\"></ba-menu>\n</aside>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baSidebar/baSidebar.html
// module id = 558
// module chunks = 52